import "../../../../src/content/mexico-city-festival/mexico-city.scss";
import * as React from 'react';
export default {
  React
};